import { RouteName } from '~~/package/enum/RouteName';

// 좌측 하단에 플로팅 런처(채널톡 또는 설문)가 뜨는 라우트(단일 소스).
// 동적 세그먼트가 경로 중간(예: /contest/:contestId/:taskId)이라 path-prefix 매칭이 불가 →
// 라우트 이름으로 매칭한다. 푸터 약관은 이 라우트에서 우측으로 들여써 좌측 런처와의 겹침을 피한다.
const BOTTOM_LEFT_LAUNCHER_ROUTES: ReadonlySet<string> = new Set<string>([
    RouteName.ContestContestIdTaskId, // /contest/:contestId/:taskId
    RouteName.LearningCourseIdTaskId, // /learning/:courseId/:taskId
    // ProSkillAssure 는 시작·진행중·종료 화면 모두 좌측 하단에 런처가 위치(채널톡 또는 설문).
    RouteName.LearningProSkillAssureAssessmentId, // /learning/proSkillAssure/:assessmentId (시작)
    RouteName.LearningProSkillAssureAssessmentIdTaskId, // /learning/proSkillAssure/:assessmentId/:taskId (진행중)
    RouteName.LearningProSkillAssureAssessmentIdCompleted, // /learning/proSkillAssure/:assessmentId/completed (종료 — 설문 런처가 좌측)
    RouteName.LearningLevelAssessmentTrackIdLevelIdTaskTemplateId, // /learning/levelAssessment/:trackId/:levelId/:taskTemplateId
]);

// 채널톡 런처/메신저 자체를 좌측 하단에 배치할 라우트. BOTTOM_LEFT_LAUNCHER_ROUTES 와 동일.
const CHANNELTALK_LEFT_ROUTES: ReadonlySet<string> = BOTTOM_LEFT_LAUNCHER_ROUTES;

// vue-router route name 은 string | symbol | null | undefined → string 만 매칭.
// 채널톡 런처/메신저를 좌측 배치할지 (8.channelTalk.client.ts).
export const isChannelTalkLeftRoute = (name: unknown): boolean =>
    typeof name === 'string' && CHANNELTALK_LEFT_ROUTES.has(name);

// 좌측 하단 런처(채널톡/설문)가 존재하는지 → 푸터 약관 들여쓰기 (LearningCommonFooterTerms.vue).
export const isBottomLeftLauncherRoute = (name: unknown): boolean =>
    typeof name === 'string' && BOTTOM_LEFT_LAUNCHER_ROUTES.has(name);
